import { Box, Switch, Typography } from "@mui/material";
import React, { Dispatch } from "react";

interface ITransportProps {
	newAddOnSettings: any;
	setNewAddOnSettings: Dispatch<any>;
}

const Transport: React.FC<ITransportProps> = ({
	newAddOnSettings,
	setNewAddOnSettings,
}) => {
	return (
		<Box
			sx={{
				backgroundColor: "#F5F5F5",
				borderRadius: "8px",
				marginTop: "32px",
				padding: "16px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "16px",
							color: "rgba(0, 0, 0, 0.87)",
						}}
					>
						Transport
					</Typography>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "12px",
							color: "rgba(0, 0, 0, 0.6)",
						}}
					>
						Let Workers book a ride to and from their Shifts. Each Location must
						also be switched on individually, once its stops exist.
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Switch
						checked={newAddOnSettings.transportEnabled ?? false}
						onChange={(e) => {
							setNewAddOnSettings((pre: any) => ({
								...pre,
								transportEnabled: e.target.checked,
							}));
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default Transport;
